(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-scroll-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.auto-scroll-track-wrapper').forEach(function (wrapper) {
      var track = wrapper.querySelector('.auto-scroll-track');
      var speed = parseFloat(wrapper.dataset.speed) || 60; // pixels par seconde
      var group = wrapper.querySelector('.auto-scroll-group');
      if (!track || !group) return;

      var groupWidth = group.getBoundingClientRect().width;
      var duration = groupWidth / speed;
      track.style.setProperty('--scroll-duration', duration + 's');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bento-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const track = document.querySelector('.bento-carousel__track');
  const dots  = document.querySelectorAll('.bento-carousel__dot');

  if (!track) return;

  track.addEventListener('scroll', function() {
    const slideWidth = track.querySelector('.bento-carousel__slide').offsetWidth + 12;
    const index = Math.round(track.scrollLeft / slideWidth);
    dots.forEach(d => d.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      const index = parseInt(dot.dataset.index);
      const slideWidth = track.querySelector('.bento-carousel__slide').offsetWidth + 12;
      track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
